import { FontIcon } from "@fluentui/react";
import { Tooltip } from "antd";

interface DeleteButtonProps {
  disabled?: boolean;
  onClick?: () => void;
}

const DeleteButton = ({ disabled, onClick }: DeleteButtonProps) => {
  return (
    <Tooltip
      placement="bottom"
      title="Delete">
      <button
        disabled={disabled}
        className="button action"
        onClick={onClick}>
        <FontIcon iconName="Delete" />
      </button>
    </Tooltip>
  );
};

export default DeleteButton;
